'use client';

import { useEffect } from 'react';
import { trackArticleRead } from '@/lib/analytics';

interface ArticleReadTrackerProps {
  articleSlug: string;
  healthGoal: string;
  supplementName: string;
}

/**
 * Invisible client component that fires the article_read GA4 event on mount.
 * Drop into the server-rendered article page.
 */
export function ArticleReadTracker({
  articleSlug,
  healthGoal,
  supplementName,
}: ArticleReadTrackerProps) {
  useEffect(() => {
    trackArticleRead({
      article_slug: articleSlug,
      health_goal: healthGoal,
      supplement_name: supplementName,
    });
  }, [articleSlug, healthGoal, supplementName]);

  return null;
}

export default ArticleReadTracker;
